import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('action-log.routes.index'),
        name: i18n.t('action-log.routes.index'),
        component: () =>
            import(
                /* webpackChunkName: "bank-accounts" */ '@/views/action-logs/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('action-log.breadcrumbs.index'),
                    to: { name: i18n.t('action-log.routes.index') },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
